import React from "react";

export const GamesSection = () => {
  return (
    <div className="relative w-full bg-transparent px-4 py-16">
      <div className="relative max-w-[1344px] mx-auto flex flex-col gap-24">
        {/* Row 1: Image + Games/Pre-orders/Investors */}
        <div className="flex flex-col-reverse lg:flex-row items-center justify-between gap-12">
          {/* Image Section */}
          <div className="w-full lg:w-[50%] flex justify-center">
            <div className="relative w-full max-w-[543px]">
              <div className="relative">
                <img
                  className="w-full max-w-[533px] h-auto"
                  alt="Baby Unicorn"
                  src="Group 69.png"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Text Section */}
          <div className="w-full lg:w-[50%] flex flex-col gap-12">
            {/* Games Section */}
            <div className="flex flex-col gap-6">
              <h2 className="font-[Baloo_2] text-2xl sm:text-3xl md:text-4xl text-white font-bold leading-tight">
                Games That Spark Joy and Learning
              </h2>
              <p className="text-white text-base sm:text-lg md:text-xl leading-8">
                Our AI engine is complete, and the physical prototype of the Baby Unicorn toy is currently in development. Within 45–60 days, we’ll unveil the first working models — and you can be among the first to own this groundbreaking toy.
              </p>
              <p className="text-white text-base sm:text-lg md:text-xl leading-8">
                By supporting us during pre-sale, you’re not only securing early access — you’re helping bring a new standard of joy and education to children worldwide.
              </p>
            </div>

            {/* Pre-Orders Section */}
            <div className="flex flex-col gap-6">
              <h2 className="font-[Baloo_2] text-2xl sm:text-3xl md:text-4xl text-white font-bold leading-tight">
                Now Accepting Pre-Orders— Be Part of the Magic
              </h2>
              <p className="text-white text-base sm:text-lg md:text-xl leading-8">
                In addition to our AI unicorn toy, we’re developing a full suite of engaging, educational mobile games designed for kids aged 2–7. These games are full of vibrant colors, fun characters, and developmental value — from learning ABCs to solving puzzles and creative play.
              </p>
              <p className="text-white text-base sm:text-lg md:text-xl leading-8">
                All games are created by early childhood experts and digital artists, ensuring a safe and enriching experience for every child.
              </p>
            </div>

            {/* Investors Section */}
            <div className="flex flex-col gap-6">
              <h2 className="font-[Baloo_2] text-2xl sm:text-3xl md:text-4xl text-white font-bold leading-tight">
                Calling All Dreamers & Believers — Investors Welcome
              </h2>
              <p className="text-white text-base sm:text-lg md:text-xl leading-8">
                We are opening the door for strategic partners and early investors to join this mission. With a unique product, a proven AI engine, and an expanding digital ecosystem, Baby Unicorn is positioned to become a leader in smart toys and children’s entertainment.
              </p>
              <p className="text-white text-base sm:text-lg md:text-xl font-semibold leading-8">
                Let’s build something magical together.
              </p>
            </div>
          </div>
        </div>

        {/* Row 2: Adventure + Collectibles */}
        <div className="flex flex-col lg:items-center gap-12">
          {/* Adventure Section */}
          <div className="w-full lg:w-[70%] flex flex-col gap-6">
            <h2 className="font-[Baloo_2] text-2xl sm:text-3xl md:text-4xl text-white font-bold leading-tight">
              The Adventure
            </h2>
            <p className="text-white text-base sm:text-lg md:text-xl leading-8">
              Once BabyU becomes a worldwide sensation, we bring the toy to life through an animated series:
            </p>
            <p className="text-pink-300 font-semibold text-base sm:text-lg md:text-xl leading-8">
              Toy updates, every week 🦄
            </p>
            <ul className="list-disc pl-6 text-white text-white sm:text-lg md:text-xl leading-8 space-y-2">
              <li className="text-white">
                <span className="font-semibold text-white">Meet Charlie & BabyU:</span> Follow BabyU on incredible adventures with his dad, Charlie – a tech genius who solves problems in the craziest, funniest ways imaginable.
              </li>
              <li className="text-white">
                <span className="font-semibold text-white">Technology Meets Humor:</span> Every obstacle is overcome using clever gadgets, wild inventions, and humor that entertains kids and adults alike.
              </li>
              <li className="text-white">
                <span className="font-semibold text-white">A Story Everyone Will Love:</span> Adventures filled with laughter, lessons, and endless imagination.
              </li>
            </ul>
          </div>

          {/* Collectibles Section */}
          <div className="w-full lg:w-[70%] flex flex-col gap-6">
            <h2 className="font-[Baloo_2] text-2xl sm:text-3xl md:text-4xl text-white font-bold leading-tight">
              The Future of Collectibles
            </h2>
            <ul className="list-disc pl-6 text-white text-base sm:text-lg md:text-xl leading-8 space-y-2">
              <li className="text-white">
                <span className="font-semibold">Exclusive NFTs:</span> Some of the most exciting moments and characters from the BabyU adventures will appear as limited-edition digital collectibles.
              </li>
              <li className="text-white">
                <span className="font-semibold">Rarity Meets Value:</span> Each NFT is designed to be rare, coveted, and valuable – offering a chance for lucky fans to own a piece of BabyU history.
              </li>
              <li className="text-white">
                <span className="font-semibold">Early Access Opportunities:</span> NFTs may be released even before the full cartoon, creating excitement and exclusivity for early supporters.
              </li>
            </ul>
          </div>

          {/* Closing Section */}
          <div className="w-full lg:w-[70%] flex flex-col gap-6">
            <p className="text-white text-base sm:text-lg md:text-xl leading-8">
              BabyU is more than a toy. It’s an ecosystem of play, storytelling, intelligent games and collectible experiences – designed to delight, inspire, and connect children and families worldwide.
            </p>
            <p className="text-white text-base sm:text-lg md:text-xl font-semibold leading-8">
              Get ready to join the BabyU adventure – where fun, innovation, learning, and imagination know no limits!
            </p>
          </div>
        </div>
      </div>

      {/* Glowing Background */}
      <div className="absolute top-0 left-0 w-[300px] h-[300px] lg:w-[570px] lg:h-[570px] bg-[#ff81bc] rounded-full blur-[200px] lg:blur-[400px] -z-10"></div>
      <div className="absolute bottom-0 right-0 w-[300px] h-[300px] lg:w-[570px] lg:h-[570px] bg-purple-400 opacity-40 rounded-full blur-[200px] lg:blur-[400px] -z-10"></div>
    </div>
  );
};
